import {
  addToCart,
  checkoutCustomStyles,
  getAllStylesByCategory,
  getAllStylesByGender,
  getOrderDetails,
  getSimilarStyles,
  getStyleCategories,
  getTrendingStyles,
  makeTailoringOrder,
  multipleCheckout,
} from "../services/tailoring";
import { useContext } from "react";
import TailoringContext from "../context/TailoringContext";
// import { CartModalContext } from "../context/CartModalContext";


const useTailoring = () => {
  const { setLoader } = useContext(TailoringContext);
  // const { setErrMsg } = useContext(CartModalContext);


  const handleGetTrendingStyle = () => {
    return new Promise((resolve, reject) => {
      setLoader(true);
      getTrendingStyles()
        .then((res) => {
          resolve(res);
          // console.log(res?.data);
          setLoader(false);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  };

  const handleGetStyleCategories = (payload) => {
    return new Promise((resolve, reject) => {
      getStyleCategories(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  const handleGetStyleByGender = (gender) => {
    return new Promise((resolve, reject) => {
      getAllStylesByGender(gender)
        .then((res) => resolve(res))
        .catch((err) => resolve(err));
    });
  };

  const handleGetStylesByCategory = (payload) => {
    return new Promise((resolve, reject) => {
      getAllStylesByCategory(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  const handleMakeTailoringOrder = (payload) => {
    return new Promise((resolve, reject) => {
      makeTailoringOrder(payload)
        .then((res) => {
          resolve(res);
          console.log(res?.data);
        })
        .catch((err) => {
          reject(err)
          console.log(err);
        });
    });
  };

  const handleAddToCart = (payload) => {
    return new Promise((resolve, reject) => {
      setLoader(true)
      addToCart(payload)
        .then((res) => {
          resolve(res);
          console.log(res.data);
          setLoader(false)
        })
        .catch((err) => {
          reject(err);
          console.log(err);
        });
    });
  };
 

  const handleMultipleCheckout = (payload) => {
    return new Promise((resolve, reject) => {
      multipleCheckout(payload).then((res) => {
        resolve(res)
        console.log(res?.data);
      }).catch((error) => {
        console.log(error);
      })
    })
  }

  const handleGetOrderDetails = () => {
    return new Promise((resolve, reject) => {
      getOrderDetails().then((res) => {
        resolve(res)
        // console.log(res?.data);
      }).catch((error) => {
        console.log(error);
      })
    })
  }

  const handleSimilarStyles = (cat) => {
    return new Promise((resolve, reject) => {
      setLoader(true);

      getSimilarStyles(cat).then((res) => {
        resolve(res)
        setLoader(false);
      }).catch((error) => {
        console.log(error);
      }).finally(() => setLoader(false))
    })
  }



  const handleGetCustomStylesCheckout = (id) => {
    return new Promise((resolve, reject) => {
      setLoader(true)

      checkoutCustomStyles(id).then((res) => {
        resolve(res)
        console.log(res?.data);
      }).catch((error) => {
        reject(error)
        console.log(error);
      }).finally(() => {
        setLoader(false)
      })
    })
  }

  return {
    handleGetTrendingStyle,
    handleGetStyleCategories,
    handleGetStyleByGender,
    handleGetStylesByCategory,
    handleMakeTailoringOrder,
    handleAddToCart,
    handleMultipleCheckout,
    handleGetOrderDetails,
    handleSimilarStyles,
    handleGetCustomStylesCheckout
  };
};

export default useTailoring;
